import Factory from "./Factory";
import {$util} from "@util/util.js";
import Constant from "@constant/index.js";

/*********************  PC *********************************/
//group
import GroupView from "@vpc/Group.js";
//Sku
import MainSkuView from "@vpc/MainSku.js";
//promotion
import BookingView from "@vpc/promotion/Booking.js";
import KillView from "@vpc/promotion/Kill.js";
import OrderReduceView from "@vpc/promotion/OrderReduce.js";
import SubscribeView from "@vpc/promotion/Subscribe.js";
import SubscribeSnapView from "@vpc/promotion/SubscribeSnap.js";
//additional
import CtoView from "@vpc/additional/Cto.js";
// import PersonalTailorView from "@vpc/additional/PersonalTailor.js";
import GiftView from "@vpc/additional/Gift.js";
import OptionListView from "@vpc/additional/OptionList.js";
import OptionView from "@vpc/additional/Option.js";
import ServiceView from "@vpc/additional/Service.js";
import PackageView from "@vpc/additional/Package.js";
import PersonalGoodsView from "@vpc/additional/PersonalGoods.js";
import GiftListView from "@vpc/additional/GiftList.js";
//price
import PriceView from "@vpc/Price.js";
//Recommend
import RecommendView from "@vpc/Recommend.js";
// Coupon
import CouponView from "@vpc/additional/Coupon.js";
// ServiceList
import ServiceListView from "@vpc/additional/ServiceList.js";

// 到货通知
import ArrivalGoodsView from "@vpc/additional/ArrivalGoods.js";


/*********************  Wap *********************************/
//group
import GroupWapView from "@vwap/Group.js";
//Sku
import MainSkuWapView from "@vwap/MainSku.js";
//promotion
import BookingWapView from "@vwap/promotion/Booking.js";
import KillWapView from "@vwap/promotion/Kill.js";
import OrderReduceWapView from "@vwap/promotion/OrderReduce.js";
import SubscribeWapView from "@vwap/promotion/Subscribe.js";
import SubscribeSnapWapView from "@vwap/promotion/SubscribeSnap.js";
//additional
import CtoWapView from "@vwap/additional/Cto.js";
import GiftWapView from "@vwap/additional/Gift.js";
import OptionWapView from "@vwap/additional/Option.js";
import ServiceWapView from "@vwap/additional/Service.js";
import PackageWapView from "@vwap/additional/Package.js";
//price
import PriceWapView from "@vwap/Price.js";
//Recommend
import RecommendWapView from "@vwap/Recommend.js";

// Coupon
import CouponWapView from "@vwap/additional/Coupon.js";

// ServiceList
import ServiceListWapView from "@vwap/additional/ServiceList.js";
// OptionList
import OptionListWapView from "@vwap/additional/OptionList.js";
// GiftList
import GiftListWapView from "@vwap/additional/GiftList.js";
// SimilarityGoods
import SimilarityGoodstWapView from "@vwap/additional/SimilarityGoods.js";
// 到货通知
import ArrivalGoodsWapView from "@vwap/additional/ArrivalGoods.js";
// 私人订制
import PersonalGoodsWapView from "@vwap/additional/PersonalGoods.js";

let _isPC = $util.isPC();
export default class ViewFactory extends Factory{
    constructor(){
        super();
    }
}

ViewFactory.prototype[Constant.MODEL_TYPES.GROUP] = (model)=>{
    return _isPC?new GroupView(model):new GroupWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.MAINSKU] = function(model){
    return _isPC?new MainSkuView(model):new MainSkuWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.PRICE] = function(model){
    return _isPC?new PriceView(model):new PriceWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.RECOMMEND] = function(model){
    return _isPC?new RecommendView(model):new RecommendWapView(model);
}


ViewFactory.prototype[Constant.MODEL_TYPES.BOOKING] = function(model){
    return _isPC?new BookingView(model):new BookingWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.KILL] = function(model){
    return _isPC?new KillView(model):new KillWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.KILL_COUNTDOWN] = function(model){
    return _isPC?new KillView(model):new KillWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.ORDER_REDUCE] = function(model){
    return _isPC?new OrderReduceView(model):new OrderReduceWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.SUBSCRIBE] = function(model){
    return _isPC?new SubscribeView(model):new SubscribeWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.SUBSCRIBESNAP] = function(model){
    return _isPC?new SubscribeSnapView(model):new SubscribeSnapWapView(model);
}


ViewFactory.prototype[Constant.MODEL_TYPES.SERVICE] = function(model){
    return _isPC?new ServiceView(model):new ServiceWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.CTO] = function(model){
    return _isPC?new CtoView(model):new CtoWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.PERSONALGOODS] = function(model){
    return _isPC?new PersonalGoodsView(model):new PersonalGoodsWapView(model);
}
// ViewFactory.prototype[Constant.MODEL_TYPES.PERSONALTAILOR] = function(model){
//     return _isPC?new PersonalTailorView(model):new PersonalTailorView(model);
// }
ViewFactory.prototype[Constant.MODEL_TYPES.GIFT] = function(model){
    return _isPC?new GiftView(model):new GiftWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.PACKAGE] = function(model){
    return _isPC?new PackageView(model):new PackageWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.PACKAGE] = function(model){
    return _isPC?new PackageView(model):new PackageWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.OPTION] = function(model){
    return _isPC?new OptionView(model):new OptionWapView(model);
}

ViewFactory.prototype[Constant.MODEL_TYPES.COUPON] = function(model){
    return _isPC?new CouponView(model):new CouponWapView(model);
}

ViewFactory.prototype[Constant.MODEL_TYPES.SERVICELIST] = function(model){
    return _isPC?new ServiceListView(model):new ServiceListWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.OPTIONLIST] = function(model){
    return _isPC?new OptionListView(model):new OptionListWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.GIFTLIST] = function(model){
    return _isPC?new GiftListView(model):new GiftListWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.SIMILARITYGOODS] = function(model){
    return _isPC?new ServiceListView(model):new SimilarityGoodstWapView(model);
}
ViewFactory.prototype[Constant.MODEL_TYPES.ARRIVALGOODS] = function(model){
    return _isPC?new ArrivalGoodsView(model):new ArrivalGoodsWapView(model);
}
